// 必须与后端 backend/src/config/policy.ts 保持一致；不一致时后端会拒绝注册/绑定（fail-safe）。
export const PRIVACY_POLICY_VERSION = 1;
